import { isAfter, isBefore } from 'date-fns'
import isString from 'lodash-es/isString'
import * as Yup from 'yup'

import { SERVER_NON_FIELD_ERROR_KEY } from '../../../constants/validation'

import {
  VIEWING_FORM_FIELD_NAME,
  VIEWING_FORM_MODE,
  VIEWING_FORM_TIME_SOURCE,
} from './RentalPortalViewingFormModal.constants'

export function getViewingFormFieldErrorProps(error) {
  return { showError: Boolean(error) }
}

export function getViewingFormSubmitErrors({ error, t }) {
  if (error?.isSlotTaken) {
    return {
      [VIEWING_FORM_FIELD_NAME.slot]: t('RentalPortal.ViewingFormSlotTakenKey'),
    }
  }

  if (error?.isOverlap) {
    return {
      [VIEWING_FORM_FIELD_NAME.start]: t('RentalPortal.ViewingFormOverlapKey'),
    }
  }

  return {
    [SERVER_NON_FIELD_ERROR_KEY]: t('RentalPortal.ViewingFormSaveErrorKey'),
  }
}

export function getViewingFormErrorText(errors) {
  return Object.entries(errors)
    .filter(
      ([name, error]) => name !== SERVER_NON_FIELD_ERROR_KEY && isString(error)
    )
    .map(([, error]) => error)
    .join(' ')
}

export function getViewingFormValidationSchema(t) {
  return Yup.object({
    [VIEWING_FORM_FIELD_NAME.applicant]: Yup.array().when(
      VIEWING_FORM_FIELD_NAME.mode,
      {
        is: VIEWING_FORM_MODE.book,
        then: schema => schema.min(1, true),
      }
    ),
    [VIEWING_FORM_FIELD_NAME.duration]: Yup.object()
      .nullable()
      .when(VIEWING_FORM_FIELD_NAME.timeSource, {
        is: VIEWING_FORM_TIME_SOURCE.slot,
        otherwise: schema => schema.required(true),
      }),
    [VIEWING_FORM_FIELD_NAME.listing]: Yup.object().nullable().required(true),
    [VIEWING_FORM_FIELD_NAME.repeatUntil]: Yup.date()
      .nullable()
      .when(VIEWING_FORM_FIELD_NAME.withRepeat, {
        is: true,
        then: schema =>
          schema.required(true).test({
            message: t('RentalPortal.ViewingFormUntilBeforeStartKey'),
            name: 'viewingFormUntilAfterStart',
            test: (value, context) =>
              !value ||
              !context.parent[VIEWING_FORM_FIELD_NAME.start] ||
              isAfter(value, context.parent[VIEWING_FORM_FIELD_NAME.start]),
          }),
      }),
    [VIEWING_FORM_FIELD_NAME.slot]: Yup.object()
      .nullable()
      .when(VIEWING_FORM_FIELD_NAME.timeSource, {
        is: VIEWING_FORM_TIME_SOURCE.slot,
        then: schema => schema.required(true),
      }),
    [VIEWING_FORM_FIELD_NAME.start]: Yup.date()
      .nullable()
      .when(VIEWING_FORM_FIELD_NAME.timeSource, {
        is: VIEWING_FORM_TIME_SOURCE.slot,
        otherwise: schema => schema.required(true),
      })
      .when(VIEWING_FORM_FIELD_NAME.mode, {
        is: VIEWING_FORM_MODE.book,
        otherwise: schema =>
          schema.test({
            message: t('RentalPortal.ViewingFormPastDateKey'),
            name: 'viewingFormStartNotPast',
            test: value => !value || !isBefore(value, new Date()),
          }),
      }),
  })
}
